// ─── Special awards ──────────────────────────────────────────────────────────

export const SPECIAL_AWARD_TYPE = {
  BIRTHDAY: 'BIRTHDAY',
  WORK_ANNIVERSARY: 'WORK_ANNIVERSARY',
  LEARNING_STREAK: 'LEARNING_STREAK',
  ATTENDANCE_STREAK: 'ATTENDANCE_STREAK',
  NEW_POSITION: 'NEW_POSITION',
} as const;

export const SPECIAL_AWARD_MODE = {
  AUTO_POST: 'AUTO_POST',
  DISABLED: 'DISABLED',
  MANAGER_NUDGE: 'MANAGER_NUDGE',
} as const;

export const SPECIAL_AWARD_MIN_CREDITS = 0;
export const SPECIAL_AWARD_MAX_CREDITS = 9999;

export const SPECIAL_AWARD_DISPLAY = {
  [SPECIAL_AWARD_TYPE.BIRTHDAY]: {
    title: 'Birthday',
    description: 'Birthday post for each employee on their day.',
  },
  [SPECIAL_AWARD_TYPE.WORK_ANNIVERSARY]: {
    title: 'Work Anniversary',
    description: "Anniversary post each year on the employee's hire date.",
  },
  [SPECIAL_AWARD_TYPE.LEARNING_STREAK]: {
    title: 'Learning Streak',
    description: 'Recognized for continuous learning streaks.',
  },
  [SPECIAL_AWARD_TYPE.ATTENDANCE_STREAK]: {
    title: 'Attendance Streak',
    description: 'Recognized for consistent attendance streaks.',
  },
  [SPECIAL_AWARD_TYPE.NEW_POSITION]: {
    title: 'New Position',
    description: 'Promotion announcement when an employee changes role.',
  },
} as const;

// ─── Redemption ──────────────────────────────────────────────────────────────

export const REDEMPTION_METHOD = {
  PAYROLL: 'PAYROLL',
  REWARD_CATALOG: 'REWARD_CATALOG',
} as const;

export const CREDIT_RATE_MIN = 1;
export const CREDIT_RATE_MAX = 1000;

// ─── Gift card account (Giftogram recharge) ──────────────────────────────────

export const RECHARGE_STATUS = {
  REQUESTED: 'REQUESTED',
  INVOICED: 'INVOICED',
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED',
} as const;

/** Status chip per recharge status. INVOICED isn't used yet but reads as still in progress. */
export const RECHARGE_STATUS_DISPLAY = {
  [RECHARGE_STATUS.REQUESTED]: { label: 'Requested', tagStatus: 'notice' },
  [RECHARGE_STATUS.INVOICED]: { label: 'Requested', tagStatus: 'notice' },
  [RECHARGE_STATUS.CONFIRMED]: { label: 'Credited', tagStatus: 'success' },
  [RECHARGE_STATUS.FAILED]: { label: 'Declined', tagStatus: 'error' },
} as const;

export const RAISE_BLOCKED_REASON = {
  NOT_COMPANY_ADMIN: 'NOT_COMPANY_ADMIN',
  CATALOG_NOT_ENABLED: 'CATALOG_NOT_ENABLED',
  REWARDS_NOT_ENABLED: 'REWARDS_NOT_ENABLED',
  REQUEST_IN_PROGRESS: 'REQUEST_IN_PROGRESS',
} as const;

/** Shown when a top up can't be raised. REQUEST_IN_PROGRESS has its own banner with the pending amount. */
export const RAISE_BLOCKED_MESSAGE = {
  [RAISE_BLOCKED_REASON.NOT_COMPANY_ADMIN]:
    'Only company admins with access to this company can raise a top up request.',
  [RAISE_BLOCKED_REASON.CATALOG_NOT_ENABLED]: 'Gift card redemption is not enabled for your organization yet.',
  [RAISE_BLOCKED_REASON.REWARDS_NOT_ENABLED]: 'Rewards is not enabled for this company.',
} as const;

/** Mirrors the server's @Digits(integer = 8, fraction = 2) on the request amount. */
export const TOP_UP_MAX_INTEGER_DIGITS = 8;
export const TOP_UP_MAX_FRACTION_DIGITS = 2;

// ─── Credit allocation caps ──────────────────────────────────────────────────

export const ALLOCATION_CAP_MIN = 1;
export const ALLOCATION_CAP_MAX = 100000;
export const EMPLOYEE_VALUE_PER_POST_MIN = 0;
